import { PagingSearch } from "./common"

export class User {
    userNo: number
    oasisUserNo: number
    userId: string
    userName: string
    refreshToken: string
    roles: string[]
    isUser: boolean = false
    isAdmin: boolean = false
    isFinance: boolean = false
    email: string
    tel: string
    regDate: string
    fireDate: string
    lastLoginDate: string
    passwordUpdateDate: string
    status: string
    receiveEmail: string
    receiveSms: string
    userType: string
    userTypeName: string
    userGrade: string
    userGradeName: string
    recommendUserNo: number
    recommendUserId: string
    password: string
    passwordConfirm: string
    otpCode: string
    userChannelList: UserChannel[] = new Array()
    corpCode: string
    cashbillYn: string
    recentlyCommissionPrice: number
    totalCommissionPrice: number
    totalPayment: number
    userClass: string
    regidentNumber: string
    corpImageFilePath: string
    depositor: string
    bankCode: string
    accountNumber: string
}
export class UserPaymentInfo {
    userNo: number
    accountNumber: string
    bankCode: string
    bankCodeName: string
    filePath: string
    depositor: string
}

export class UserChannel {
    userChannelNo: number
    channelType: string = ''
    channelTypeName: string
    channelUrl: string
    imageFilePath: string
    isOk: boolean = false
}

export class ConfirmHistory {
    comment: string
    confirmUserNo: number
    historyNo: number
    regDate: string
    status: string
    statusName: string
    userNo: number
}
export class ActivityHistory {
    activityInfo: string
    activityType: string
    clientIp: string
    historyNo: number
    regDate: string
    userAgent: string
    userAgentPlatform: string
    browser: string
    os: string
    userNo: number
}


export class UserSearch extends PagingSearch{
    userNo: number
    tel: string
    userId: string
    userName: string
    userType: string
    userGrade: string
    status: string
    userClass: string
    searchType: string // id, userName, corpCode, recommmendUserId
    searchDateType: string // regDate, lastLoginDate
}

export class OasisUser {
    userName: string
    userId: string
    userNo: number
    totPayment: number
    totPartCancelPrice: number
    totRefundPrice: number
    totRefundPoint: number
    totBuyCount: number
    totBuyPrice: number
    totQnaCount: number
    totProductQnaCount: number
    point: number
    joinSource: string
    lastBuyDt: string
    lastLoginDt: string
    regDate: string
    oasisRegDt: string
    setGradeDt: string
    receiveSms: string
    status: string
    tel: string
    userType: string
    userGrade: string
    gradeStatus: string
    gradeStatusName: string
    socialName: string
}

export class UserMemo {
    adminUserName: string
    adminUserNo: number
    memo: string
    memoNo: number
    regDate: string
    status: string
    userName: string
    userNo: number
}